"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOutreachEmailPolicyPayload = void 0;
var CreateOutreachEmailPolicyPayload;
(function (CreateOutreachEmailPolicyPayload) {
    let stage;
    (function (stage) {
        stage["INITIAL_INVITE"] = "initialInvite";
        stage["DIDNT_OPEN_OFFER_PAGE"] = "didntOpenOfferPage";
        stage["OPENED_OFFER_PAGE"] = "openedOfferPage";
        stage["ACCEPTED_OFFER"] = "acceptedOffer";
        stage["ACCEPTED_TERMS"] = "acceptedTerms";
        stage["FINISHED_RUNNING"] = "finishedRunning";
        stage["RUNNING"] = "running";
    })(stage = CreateOutreachEmailPolicyPayload.stage || (CreateOutreachEmailPolicyPayload.stage = {}));
    let emailDeliveryPlatform;
    (function (emailDeliveryPlatform) {
        emailDeliveryPlatform["SENDGRID"] = "sendgrid";
        emailDeliveryPlatform["MIXMAX"] = "mixmax";
    })(emailDeliveryPlatform = CreateOutreachEmailPolicyPayload.emailDeliveryPlatform || (CreateOutreachEmailPolicyPayload.emailDeliveryPlatform = {}));
    let recipient;
    (function (recipient) {
        recipient["DIRECT"] = "direct";
        recipient["AGENCY"] = "agency";
    })(recipient = CreateOutreachEmailPolicyPayload.recipient || (CreateOutreachEmailPolicyPayload.recipient = {}));
})(CreateOutreachEmailPolicyPayload = exports.CreateOutreachEmailPolicyPayload || (exports.CreateOutreachEmailPolicyPayload = {}));
